module.exports = __webpack_public_path__ + "media/images/chevron-down-8624f04faf16b2d07c00235d9dc68ae2.svg";